import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renameItem from '../../../../actions/renameItem';
import RenameItemButton from './RenameItemButton';
import { create } from '../../../../helpers/validationFunctionFactory';

const mapStateToProps = ({ estimateBuilder }, ownProps) => {
  const { estimates, containers, items } = estimateBuilder.entities;
  const { selectedEstimate } = estimateBuilder.uiState;
  const parentContainer = estimates.byId[selectedEstimate].containers
    .map(givenId => containers.byId[givenId])
    .find(givenContainer => givenContainer.items.indexOf(ownProps.itemId) !== -1);

  const nameList = parentContainer.items
    .filter(givenId => givenId !== ownProps.itemId)
    .map(givenId => items.byId[givenId].label);

  const validateFunction = create(nameList, 10, 'Window name');

  return {
    validate: validateFunction,
    defaultName: items.byId[ownProps.itemId].label,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ renameItem }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RenameItemButton);
